import { render, staticRenderFns } from "./ManageStaffSkillsQualificationHome.vue?vue&type=template&id=38107d6a&lang=true&"
import script from "./ManageStaffSkillsQualificationHome.vue?vue&type=script&lang=js&"
export * from "./ManageStaffSkillsQualificationHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports